import React from 'react';
import styles from './Sponsors.module.css';

const sponsorCards = [
  {
    image: '/assets/images/sponsor-shine.jpg',
    titleLine1: 'Shine bright',
    titleLine2: 'like a diamond :',
    text: (
      <>
        <strong className={styles.cardTextBold}>Briller comme jaja</strong> auprès des principaux acteurs du
        commerce B2B, en mettant en avant votre expertise et vos solutions
        innovantes.
      </>
    ),
  },
  {
    image: '/assets/images/sponsor-brand.jpg',
    titleLine1: 'pimp',
    titleLine2: 'your brand :',
    text: (
      <>
        Grâce à des opportunités de branding et de promotion via nos canaux
        marketing, incluant mentions sur les réseaux sociaux, newsletters, et
        bien plus.
      </>
    ),
  },
  {
    image: '/assets/images/sponsor-standup.jpg',
    titleLine1: 'get up,',
    titleLine2: 'stand up :',
    text: <>Engager directement vos prospects cibles.</>,
  },
];

const Sponsors: React.FC = () => {
  return (
    <section className={styles.sponsors}>
      <h2 className={styles.title}>
        Vous souhaitez en être ? Mais la party est réservée aux professionnels
        du B2B.
      </h2>
      <p className={styles.subtitle}>
        Vous êtes une agence, une tech ? Y'a moyen de s'arranger si vous
        souhaitez :
      </p>
      <div className={styles.cards}>
        {sponsorCards.map((card, index) => (
          <div key={index} className={styles.card}>
            <img
              src={card.image}
              alt={`${card.titleLine1} ${card.titleLine2}`}
              className={styles.cardImage}
            />
            <h3 className={styles.cardTitle}>
              {card.titleLine1}
              <br />
              {card.titleLine2}
            </h3>
            <p className={styles.cardText}>{card.text}</p>
          </div>
        ))}
      </div>
      <a href="mailto:hello@brands2buyers.io" className={styles.button}>Sponsoriser Brands2Buyers</a>
    </section>
  );
};

export default Sponsors;
